<template>
  <SeoPage page-key="gestioneSocialMediaLugano" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'GestioneSocialMediaLuganoPage'
})
</script>

